/* Copyright 2013 - 2024 Waiterio LLC */
/** @jsx jsx */
import React, { Suspense } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { jsx } from '@emotion/react'
import { useTranslation } from '@multilocale/react/index.js'
import getRestaurants from '@waiterio/api-client/getRestaurants.js'
import allAreas from '@waiterio/takeaway/areas.js'
import locales from '../locales.js'

export const paths = locales.map(locale => ({
  path: `/takeaway/${locale}/area-:area`,
  props: {
    locale,
  },
}))

export const Head = ({ locale }) => {
  const { area: areaName } = useParams()
  let [language] = locale.split('-')
  const { t } = useTranslation(language)
  let area = allAreas.find(
    area => area.name.toLowerCase() === areaName.toLowerCase(),
  ) || { city: '' }
  const cityName = area.city.charAt(0).toUpperCase() + area.city.slice(1)

  const title = `${t('Takeaway')} ${cityName} ${areaName} | Waiterio`

  const description = t('Takeaway from the best restaurants in {city}').replace(
    '{city}',
    `${cityName} ${areaName}`,
  )

  return (
    <>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
    </>
  )
}

const AreaPage = ({ locale }) => {
  const { area: areaName } = useParams()
  let area = allAreas.find(
    area => area.name.toLowerCase() === areaName.toLowerCase(),
  ) || { city: '' }
  let areas = allAreas.filter(
    area_ => area_.city.toLowerCase() === area.city.toLowerCase(),
  )
  const cityName = area.city.charAt(0).toUpperCase() + area.city.slice(1)

  return (
    <div css={{ textAlign: 'center' }}>
      <h1>Area {areaName}</h1>
      <Suspense fallback={<p>loading</p>}>
        <RestaurantsSection zipcode={areaName} />
      </Suspense>
      <h2>
        Other areas in{' '}
        <a href={`/takeaway/${locale}/city-${area.city}`}>{cityName}</a>
      </h2>
      <div css={{ display: 'flex', flexWrap: 'wrap' }}>
        {areas.map(area => (
          <a
            key={area.name}
            href={`/takeaway/${locale}/area-${area.name.toLowerCase()}`}
            css={{ flexBasis: '25%', padding: 16 }}
          >
            {area.name} {cityName}
          </a>
        ))}
      </div>
    </div>
  )
}

const RestaurantsSection = ({ zipcode }) => {
  const { data: restaurants } = useQuery({
    queryKey: 'restaurants',
    queryFn: () =>
      getRestaurants({
        // countryCode,
        zipcode,
      }),
  })

  // const [restaurants, setRestaurants] = useState()

  // useEffect(() => {
  //   const fetchRestaurants = async () => {
  //     try {
  //       if (!restaurants || !restaurants.length) {
  //         // const countryCode = 'IT'
  //         const zipcode = areaName

  //         // this.setState({
  //         //   loading: true,
  //         // })

  //         let restaurants = await getRestaurants({
  //           // countryCode,
  //           zipcode,
  //         })

  //         console.log('restaurants', restaurants)

  //         setRestaurants(restaurants)
  //       }
  //     } catch (error) {
  //       // this.setState({
  //       //   loading: false,
  //       //   error,
  //       // })
  //     }
  //   }

  //   fetchRestaurants()
  // }, [])

  return restaurants?.map(restaurant => (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      key={restaurant._id}
      href={`https://${(
        restaurant.vanityId || restaurant._id
      ).toLowerCase()}.waiterio.com`}
      css={{ display: 'block', padding: 8 }}
      target="_blank"
    >
      {restaurant.name}
    </a>
  ))
}

export default AreaPage
